import styled, { css } from "styled-components";

const btn = (light, dark) => css`
  white-space: nowrap;
  display: inline-block;
  border-radius: 5px;
  padding: 10px 25px;
  font-size: 20px;
  color: white;
  &:visited {
    color: white;
  }
  background-image: linear-gradient(${light}, ${dark});
  border: 1px solid ${dark};
  &:hover {
    background-image: linear-gradient(${light}, ${dark});
    &[disabled] {
      background-image: linear-gradient(${light}, ${dark});
    }
  }
  &:visited {
    color: black;
  }
  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const btnDefault = css`${btn("#ffffff", "#d5d5d5")} color: #555;`;

const btnPrimary = btn("rgba(35, 45, 75, 0.8)", "#232D4B");

export default styled.div`
  font-family: 'Libre Franklin', sans-serif;
  font-size: 16px;

  h1 {
    /* text-align: center; */
    color: #222;
    font-weight: 900;
    font-family: 'Libre Franklin', sans-serif;
    letter-spacing: "2px";
  }

  h2 {
    /* text-align: center; */
    color: #222;
    font-weight: 900;
    font-family: 'Libre Franklin', sans-serif;
    letter-spacing: "1px";
    margin-top: 25px;
  }

  h3 {
    margin: 25px 0px 15px;
    font-weight: 900;
    font-family: 'Libre Franklin', sans-serif;
    font-size: 20px;
  }

  & > .link {
    border-radius: 5px;
    padding: 12px 25px;
    font-size: 20px;
    color: white;
    background-image: linear-gradient(rgba(35, 45, 75, 0.8), #232D4B);
    border: 1px solid #232D4B;
    cursor: pointer;
    margin: 20px 0px;
    text-align: center;
    width: 250px;
  }

  & > .projects {
    margin: 30px 0;

    h3 {
      margin: 0;
    }

    h4 {
      margin: 0;
      font-weight: 400;
      font-family: 'Libre Franklin', sans-serif;
      font-size: 16px;
    }
  }

  & > .project-status {
    border: 3px solid rgba(35, 45, 75, .75);
    margin: 25px 0;
    padding: 25px;
    width: 50%;
  }

  & > .project-details {
    background-color: #ececec;
    padding: 25px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-around;

    table {
      border-collapse: collapse;
    }

    tr:nth-child(odd) {
        background-color: #f9f9f9;
    }

    tr:nth-child(even) {
        background-color: #fff;
    }
  }

  & > .project-tags {
      margin: 10px 0 40px;

      table {
        border-collapse: collapse;
      }

      tr:nth-child(odd) {
          background-color: #f9f9f9;
      }
  }

  .project-resource {
    font-weight: 900;
  }

  .project-sensitivity {
    background-color: rgba(229, 114, 0, .75);
    color: #fff;
    font-weight: 900;
    font-size: 14px;
    text-transform: uppercase;
  }

  .member-details {
    /* td {
      max-width: 25%;
    } */
  }

  .search-headers {
    background-color: rgba(35, 45, 75, .75);
    color: #fff;
    margin: 50px auto;
    padding: 25px 10px;
    width: 100%;
  }

  .headings-row {
    background-color: rgba(35, 45, 75, .75);
    color: #fff;
    font-weight: 900;
    font-size: 14px;
    text-transform: uppercase;
  }

  .log-link {
    color: #0000EE;
    text-decoration: underline;
    cursor: pointer;
  }

  .logs {
    .log-entries {
      cursor: pointer;
      padding: 10px;
      marginBottom: 25px;
    }

    .log-entry {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;

      .log-label {
        display: inline-block;
        font-weight: bold;
        text-align: left;
        width: 100px;
      }

      .log-value {
        display: inline-block;
        width: 300px;
      }
    }
  }

  td {
    padding: 10px 15px;
  }

  & > div {
    /* text-align: center; */
  }

  a {
    display: block;
    text-align: center;
    color: #222;
  }

  form {
    max-width: 800px;
    width: 90%;
    margin: 10px auto;
    border: 1px solid #ccc;
    padding: 30px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 3px;

    .approve-field {
      display: block;
      margin: 20px 0;
      font-weight: 900;
    }

    table {
      border-collapse: collapse;
    }

    tr:nth-child(odd) {
        background-color: #f9f9f9;
    }

    td {
      border: 1px solid #ccc;
      margin: 0;
      padding: 10px 15px;
    }

    input[type="radio"] {
      margin-right: 10px;
    }

    input[type="checkbox"] {
      margin-right: 10px;
    }

    input[type="text"] {
      height: 2em;
      width: 21em;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 3px 5px;
    }

    textarea {
      padding: 3px 5px;
      font-size: 1em;
      height: 50px;
      width: 250px;
      border: 1px solid #ccc;
      border-radius: 3px;
    }

    & > div {
      /* display: flex;
      flex-flow: row nowrap; */
      line-height: 2em;
      margin: 5px;
      & > label {
        color: #333;
        width: 110px;
        font-size: 1em;
        line-height: 32px;
      }
      & > input,
      & > select {
        flex: 1;
        padding: 3px 5px;
        font-size: 1em;
        height: 50px;
        width: 250px;
        border: 1px solid #ccc;
        border-radius: 3px;
      }
      & > input[type="checkbox"] {
        margin-top: 7px;
      }
      & > div {
        /* margin-left: 16px; */
        & > label {
          display: block;
          & > input {
            margin-right: 3px;
          }
        }
      }
      & > span {
        line-height: 32px;
        margin-left: 10px;
        color: #800;
        font-weight: bold;
      }
    }
    & > .buttons {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      margin-top: 15px;
    }
    button {
      margin: 0 10px;
      &[type="submit"] {
        ${btnPrimary};
      }
      &[type="button"] {
        ${btnDefault};
      }
    }
    pre {
      border: 1px solid #ccc;
      background: rgba(0, 0, 0, 0.1);
      box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.2);
      padding: 20px;
    }
  }
`;
